// extracted by mini-css-extract-plugin
module.exports = {"root":"AccordianList_root__Kjc_2","dark":"AccordianList_dark__gQPn9","light":"AccordianList_light__akbAl"};